import React, { useState, useEffect, useRef } from "react";
import Router, { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import moment from "moment";
import { experimentalStyled as styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import useSound from 'use-sound';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import Timer from './display';
import _ from 'lodash';
import DialogTitle from '@mui/material/DialogTitle';
import LinearWithValueLabel from 'components/progress';
import Countdown from 'react-countdown';
import Image from "next/image";
import { useLocalStorage } from 'hooks/localstorage';
import { useTranslations } from 'next-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { countdownsState, timerInfoState } from 'store/atoms';
import {
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
    TwitterShareButton,
    TwitterIcon
} from "next-share";










// Renderer callback with condition
const renderer = ({ days, hours, minutes, seconds, completed, props }) => {

    // Render a countdown
    return <div style={{ color: props.color, fontFamily: props.blockstyle.value }} className="digital_clock_style">
        {days ? `${days}` : '00'}<span style={{ color: props.color }} className='days-span'>{`Days`}</span>
        {props.keyFiguration !== 'onlydays' ? `${hours.toString().length < 2 ? `0${hours}` : hours}:${minutes.toString().length < 2 ? `0${minutes}` : minutes}:${seconds.toString().length < 2 ? `0${seconds}` : seconds}` : ''}

    </div>;

};

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export default function Main({ index, timer: timerObj, removeItem = () => { }, embed = false, singleTimer, fullscreenfn = null, shared = false }) {

    const timer_type = timerObj.type;
    let time_by_moment = moment(timerObj.datetimer);
    let _started = timerObj.started ? timerObj.started : false;



    const defaultAlarm = time_by_moment;
    const routeUrl = location.protocol + '//' + location.host + location.pathname;
    const baseUrl = location.protocol + '//' + location.host;
    const shareUrl = `${routeUrl}#${encodeURIComponent(JSON.stringify(timerObj))}`;
    const sound = timerObj.sound ? timerObj.sound : 'iphone_alarm.mp3';
    const router = useRouter();
    const [alarm, setAlarm] = useState(defaultAlarm);



    const [openAlarm, setOpenAlarm] = React.useState(false);
    const t = useTranslations();
    const [play, { stop }] = useSound(`/${sound}`);
    const [lsmode, setLsmode] = useLocalStorage("lsmode");
    const [openRemove, setOpenRemove] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openShare, setOpenShare] = useState(false);
    const prevTimer = usePrevious({ ...timerObj });
    const [started, setStarted] = useState(_started);
    const [countdownApi, setCountdownApi] = useState(null);
    const countdowns = useRecoilValue(countdownsState);
    const setCountdowns = useSetRecoilState(countdownsState);
    const timerinfo = useRecoilValue(timerInfoState);
    const setTimerinfo = useSetRecoilState(timerInfoState);
    const [lsStartedTimers, setLsStartedTimers] = useLocalStorage("lsStartedTimers");
    const [lstimers, setLstimers] = useLocalStorage("lstimers");

    useEffect(() => {
        if (prevTimer && (prevTimer?.total_in_ms_raw !== timerObj.total_in_ms_raw)) {
            console.log("====useEffect====", timerObj);
            setAlarm(moment(timerObj.total_in_ms));
        }
    }, [timerObj]);
    useEffect(() => {
        if (timerObj?.started_outside) {
            setStarted(true);
            setInStore('started', true);
        }
    }, []);

    useEffect(() => {
        if (timerinfo.paused) {
            countdownApi && countdownApi.pause();
            Router.reload(window.location.pathname);
            console.log("timerinfo", timerinfo);
        }

    });



    const openAlarmModal = (e) => {
        setOpenAlarm(true);
    };

    const closeAlarmModal = () => {
        setOpenAlarm(false);
    };

    const closeTrashDialog = () => {
        setOpenRemove(false);
    };
    const closeEditDialog = () => {
        setOpenEdit(false);
    };

    const setInStore = (field = 'started', value = false, id = null) => {
        let _id = timerObj?.id || id;
        if (_id) {
            setCountdowns([...(countdowns ? countdowns.map(v => {
                if (v.id === _id) {
                    return {
                        ...v,
                        [field]: value,
                        started_outside: false
                    }
                } else {
                    return v
                }
            }) : [])]);
        };
    }

    const stopAlarm = () => {
        stop();
        setInStore();
        setAlarm(defaultAlarm);



        closeAlarmModal();
        Router.reload(window.location.pathname);
    }

    const raiseAlarm = () => {
        openAlarmModal();
        play();
    }

    const handleTick = (data) => {
        //  setInStore('total_in_ms_raw_left', data.total);

    }



    const removeAlarm = () => {
        setOpenRemove(true)
    }

    const editAlarm = () => {
        setOpenEdit(true)
    }

    const shareCountdown = () => {



        // setOpenEdit(true)
    }
    const openShared = () => {
        console.log("===shareUrl====", shareUrl);
        setOpenShare(!openShare);

        // setOpenEdit(true)
    }

    const reset = () => {
        const time_by_moment = started ? moment().add(timerObj.total_in_ms_raw + 500, 'milliseconds') : moment(timerObj.total_in_ms);
        let total_in_ms = moment().add(timerObj.total_in_ms_raw, 'milliseconds').valueOf();
        setInStore('total_in_ms', total_in_ms);
        setAlarm(time_by_moment);

    };
    const start = () => {
        setStarted(true);
        setInStore('started', true);
        countdownApi && countdownApi.start();
    };


    const pause = () => {
        countdownApi && countdownApi.pause();
    };
    const setRef = (countdown) => {
        if (countdown) {
            setCountdownApi(countdown.getApi());
        }
    }
    const complete = (e) => {

        setStarted(false);
        //setTimer(Date.now());
        setRepeated(false);
        setOpenAlarm(true);
        play();

        console.log("completed");
    };


    const handlePause = (e) => {
        setStarted(false);
        setInStore();

        //setTimer(Date.now() + e.total);
    }
    const handleStop = (e) => {
        setStarted(false);

        const time_by_moment = timerObj.started ? moment(timerObj.total_in_ms) : moment().add(timerObj.total_in_ms_raw + 500, 'milliseconds');

        setAlarm(time_by_moment);
    }



    return (
        <>
            <div className={singleTimer <= 1 ? `preview-container w-100` : ` preview-container preview-container-middle`}>

                <div className={singleTimer > 1 ? "bg-div-cover bg-big d-none" : "bg-div-cover bg-big"} style={timerObj.bg.is_color ? { background: timerObj.bg.value } : {
                    background: `url(/images/bgimagesmy/${timerObj.bg.name}_1012_270.jpg) no-repeat center center`

                }} ></div>
                <div className={singleTimer > 1 ? "bg-div-cover bg-middle d-block" : "bg-div-cover bg-middle"} style={timerObj.bg.is_color ? { background: timerObj.bg.value } : {
                    background: `url(/images/bgimagesmy/${timerObj.bg.name}_523_236.jpg) no-repeat center center`

                }} ></div>
                <div className="bg-div-cover bg-small" style={timerObj.bg.is_color ? { background: timerObj.bg.value } : {
                    background: `url(/images/bgimagesmy/${timerObj.bg.name}_330_220.jpg) no-repeat center center`

                }} ></div>
                <div className="preview-container-content">
                    <div style={{ color: timerObj.text_colors.date_time }} className='title'>
                        {timerObj.title}
                    </div>
                    <div className='countdown'>
                        <Countdown
                            daysInHours={false}
                            autoStart={started}
                            onComplete={() => raiseAlarm()}
                            title={timerObj.title}
                            t={t}
                            keyFiguration={timerObj?.keyFiguration}
                            className="digital_clock_style"
                            date={alarm.format()}


                            ref={setRef} onPause={handlePause} onStop={handleStop}
                            color={timerObj.text_colors.digits}
                            blockstyle={timerObj.blockstyle}

                            renderer={renderer}
                        />
                    </div>
                    <div className='date' style={{ color: timerObj.text_colors.date_time }}>
                        {defaultAlarm.format('DD MMMM YYYY')}
                    </div>
                    <div className="simple-display-operations simple-display-operations-countdown">

                        <div className={openShare ? "remove-button share-button-div  share-button-div-selected d-flex" : "remove-button share-button-div   d-flex"}>
                            <div onClick={openShared} className={openShare ? "circle" : "gray-circle circle"}>
                                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 0V4C4 5 1 10 0 15C2.5 11.5 6 9.9 11 9.9V14L18 7L11 0ZM13 4.83L15.17 7L13 9.17V7.9H11C8.93 7.9 7.07 8.28 5.34 8.85C6.74 7.46 8.54 6.37 11.28 6L13 5.73V4.83Z" fill="#444D67" />
                                </svg>
                            </div>

                            {openShare && <div className="share-btns">
                                <TwitterShareButton
                                    url={"https://github.com/Bunlong/next-share"}
                                    quote={
                                        "next-share is a social media share buttons for your next React apps."
                                    }
                                    hashtag={"#nextshare"}
                                >
                                    <TwitterIcon size={40} round />
                                </TwitterShareButton>
                                <FacebookShareButton
                                    url={shareUrl}
                                    quote={
                                        "next-share is a social media share buttons for your next React apps."
                                    }

                                >
                                    <FacebookIcon size={40} round />
                                </FacebookShareButton>

                                <LinkedinShareButton
                                    url={"https://github.com/Bunlong/next-share"}
                                    quote={
                                        "next-share is a social media share buttons for your next React apps."
                                    }
                                    hashtag={"#nextshare"}
                                >
                                    <LinkedinIcon size={40} round />
                                </LinkedinShareButton>
                            </div>}

                        </div>
                        {!openShare && <div onClick={editAlarm} className="remove-button  gray-circle circle">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.71667 5.5L10.5 6.28333L2.93333 13.8333H2.16667V13.0667L9.71667 5.5ZM12.7167 0.5C12.5083 0.5 12.2917 0.583333 12.1333 0.741667L10.6083 2.26667L13.7333 5.39167L15.2583 3.86667C15.5833 3.54167 15.5833 3 15.2583 2.69167L13.3083 0.741667C13.1417 0.575 12.9333 0.5 12.7167 0.5ZM9.71667 3.15833L0.5 12.375V15.5H3.625L12.8417 6.28333L9.71667 3.15833Z" fill="#444D67" />
                            </svg>
                        </div>}
                        {!openShare && <div onClick={removeAlarm} className="remove-button  gray-circle circle">
                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.50004 0.5V1.33333H0.333374V3H1.16671V13.8333C1.16671 14.2754 1.3423 14.6993 1.65486 15.0118C1.96742 15.3244 2.39135 15.5 2.83337 15.5H11.1667C11.6087 15.5 12.0327 15.3244 12.3452 15.0118C12.6578 14.6993 12.8334 14.2754 12.8334 13.8333V3H13.6667V1.33333H9.50004V0.5H4.50004ZM2.83337 3H11.1667V13.8333H2.83337V3ZM4.50004 4.66667V12.1667H6.16671V4.66667H4.50004ZM7.83337 4.66667V12.1667H9.50004V4.66667H7.83337Z" fill="#8A90A0" />
                            </svg>
                        </div>}
                    </div>
                </div>
            </div>


            <Dialog className="trashDialog" open={openRemove} onClose={closeTrashDialog}>
                <DialogContent>
                    <div className="message-text">
                        {t("Are you sure you want to delete this timer?")}
                    </div>
                    <DialogActions>
                        <Button className="cancelButton" onClick={closeTrashDialog}>{t('Cancel')}</Button>
                        <Button className="deleteButton" onClick={() => { removeItem(index); setOpenRemove(false); }}>{t('Delete')}</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog className="editDialog timer-container countdown-container-dialog" open={openEdit} onClose={closeEditDialog}>
                <DialogContent>
                    <Timer timerObj={timerObj} exrtaProps={{ toggleclass: 'editdialogclass', fromdialog: true }} />

                </DialogContent>
                <DialogActions>
                    <Button className="cancelButton" onClick={closeEditDialog}>{t('Cancel')}</Button>

                </DialogActions>
            </Dialog>
            <Dialog className="alarmDialog" open={openAlarm} onClose={closeAlarmModal}>
                <div onClick={stopAlarm} className="removeSign">
                    <Image width="14px" alt='remove' height="14px" src={'/images/remove-sign.svg'} />
                </div>
                <DialogTitle>{t('key_alarm')}</DialogTitle>
                <DialogContent className="m-w-250">
                    <div className="alarm-clock">
                        <Image alt='remove' width={'48px'} height={'48px'} src={'/images/icon_clock_black.svg'} />
                    </div>
                    <DialogActions>
                        <div className="btn-div">
                            <Button onClick={stopAlarm} variant="contained" startIcon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2.3125C10.6868 2.3125 9.38642 2.57116 8.17317 3.0737C6.95991 3.57625 5.85752 4.31285 4.92893 5.24143C3.05357 7.1168 2 9.66034 2 12.3125C2 14.9647 3.05357 17.5082 4.92893 19.3836C5.85752 20.3122 6.95991 21.0487 8.17317 21.5513C9.38642 22.0538 10.6868 22.3125 12 22.3125C14.6522 22.3125 17.1957 21.2589 19.0711 19.3836C20.9464 17.5082 22 14.9647 22 12.3125C22 10.9993 21.7413 9.69892 21.2388 8.48567C20.7362 7.27241 19.9997 6.17002 19.0711 5.24143C18.1425 4.31285 17.0401 3.57625 15.8268 3.0737C14.6136 2.57116 13.3132 2.3125 12 2.3125ZM12 4.3125C16.41 4.3125 20 7.9025 20 12.3125C20 16.7225 16.41 20.3125 12 20.3125C7.59 20.3125 4 16.7225 4 12.3125C4 7.9025 7.59 4.3125 12 4.3125ZM9 9.3125V15.3125H15V9.3125" fill="white" />
                            </svg>
                            } >
                                {t('Stop')}
                            </Button>
                        </div>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    )

}


